// @flow
import React from 'react'
import type { Crop, Image, PersistedImage } from '../../types'
import ImagePreview from '../../ImagePreview'
import ResponsibleRect from '../ResponsibleRect'
import getDefaultCrop from '../../getDefaultCrop'

type Props = {|
  image?: ?Image | ?PersistedImage,
  imageCrop: ?Crop,
  ratio: number,
  width: number,
  height?: number,
  block?: boolean,
  float?: boolean
|}

export default function OptionalResponsibleImage(props: Props) {
  const { width, ratio, block, float, image, height, imageCrop } = props

  if (image) {
    const crop: Crop = imageCrop || getDefaultCrop(image.width, image.height, ratio)

    return (
      <ImagePreview
        width={width}
        height={height}
        imageSrc={image.src}
        size={{ width: image.width, height: image.height }}
        crop={crop}
        block={block}
        float={float}
      />
    )
  } else {
    return <ResponsibleRect width={width} ratio={ratio} block={block} float={float} />
  }
}
